import { AppThunk } from "@Store/index";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import getVideoPageData from "./getVideoPageData";

interface VideoPageData {
  readyStatus: "invalid" | "request" | "success" | "failure";
  data: any;
  reviewData: any;
  videos: Array<any>;
  selectedVideoId: string | null;
  error: any;
  dataSource: "gallery" | "api";
}

export const initialState: VideoPageData = {
  readyStatus: "invalid",
  data: null,
  reviewData: null,
  videos: [],
  selectedVideoId: null,
  error: "",
  dataSource: "api",
};

const videoPageData = createSlice({
  name: "videoPageData",
  initialState,
  reducers: {
    getVideoPageRequesting: (state: VideoPageData) => {
      state.readyStatus = "request";
      state.error = "";
      state.dataSource = "api";
    },
    getVideoPageSuccess: (state: VideoPageData, { payload }: PayloadAction<any>) => {
      state.data = payload.data;
      state.reviewData = payload.reviewData;
      state.videos = payload.videos;
      state.selectedVideoId = payload.selectedVideoId;
      state.readyStatus = "success";
      state.dataSource = payload.dataSource || "api";
    },
    getVideoPageError: (state: VideoPageData, { payload }: PayloadAction<any>) => {
      state.error = payload;
      state.readyStatus = "failure";
    },
  },
});

export const fetchVideoPageDataIfNeeded =
  (props: any): AppThunk =>
  async (dispatch) => {
    const id = props?.match?.params?.id || props?.params?.id || props?.id;
    const videoId = props?.match?.params?.videoId || props?.params?.videoId || props?.videoId;

    return dispatch(
      getVideoPageData({
        id,
        videoId,
        staticContext: props.staticContext || {},
      }),
    );
  };

export default videoPageData.reducer;

export const { getVideoPageRequesting, getVideoPageSuccess, getVideoPageError } =
  videoPageData.actions;
